// Плашка статуса матча по машинному ключу badge (гид §2.9, Figma StatusBadge): «смысл несёт точка, а не заливка».
// live, super_over — красная плашка; перерывы — серая с жёлтой точкой; дождь/задержка — серая с синей; неживые —
// серый текст без точки. Набор открытый: незнакомый ключ — нейтрально, подпись — badge_label.
import styles from './StatusBadge.module.css';

export type BadgeTone = 'live' | 'break' | 'rain' | 'neutral';

const TONES: Record<string, BadgeTone> = {
  live: 'live', super_over: 'live',
  innings_break: 'break', break: 'break', stumps: 'break',
  // после жеребьёвки до первого мяча (статус ещё NS, is_live уже true) — в макете нет, ближе всего к паузам
  toss: 'break',
  interrupted: 'rain', delayed: 'rain',
};

export function badgeTone(badge: string): BadgeTone {
  return TONES[badge] ?? 'neutral';
}

export function StatusBadge({ badge, label, className }: { badge: string; label: string; className?: string }) {
  const tone = badgeTone(badge);
  return (
    <span className={`${styles.badge} ${styles[tone]} ${className ?? ''}`} data-badge={badge}>
      {tone !== 'neutral' && <span className={styles.dot} aria-hidden="true" />}
      <span className={styles.label}>{label}</span>
    </span>
  );
}
